import { put, select, take } from 'redux-saga/effects';

import { ISubscriptionWellfunnel } from 'api/components/Subscriptions/types';

import { openModal } from 'store/modals/actions';
import { CLOSE_MODAL } from 'store/modals/actionTypes';
import { selectDiscountSubscription } from 'store/subscriptions/selectors';

import { ModalName } from 'modals/types';

import { getCancelSubscriptionSuccessModalData } from 'helpers/subscriptions';

import { IDiscountSubscription } from 'types/subscription';

export function* callSuccessCancellingBehaviour({
    cancellationCandidates,
}: {
    cancellationCandidates: ISubscriptionWellfunnel[];
}) {
    yield put(
        openModal(ModalName.SuccessModal, {
            ...getCancelSubscriptionSuccessModalData(cancellationCandidates),
        })
    );

    const discountSubscription: IDiscountSubscription | null = yield select(selectDiscountSubscription);

    if (discountSubscription) {
        yield take(CLOSE_MODAL);
        yield put(
            openModal(ModalName.ReturnModal, {
                isExtraOffer: true,
            })
        );
    }
}
